import { DateTime } from 'luxon'

import { getBanStatus } from '@/assets/composables/endpoints'
import store from '@/js/store'

// refreshBanStatus fetches the current user's booking ban and stores it (as a
// DateTime) when still active. Failures are swallowed on purpose: the ban banner
// is purely informational — enforcement always happens server-side.
export const refreshBanStatus = async (): Promise<void> => {
  try {
    const { bannedUntil, reason } = await getBanStatus()

    if (bannedUntil) {
      const until = DateTime.fromISO(bannedUntil)
      if (until.isValid && until > DateTime.now()) {
        await store.dispatch('setBanInfo', { bannedUntil: until, reason: reason ?? null })
        return
      }
    }

    await store.dispatch('setBanInfo', null)
  } catch {
    // Non-fatal — leave whatever ban state is already in the store.
  }
}
